import { useFormik } from 'formik'
import { useState } from 'react'

import fetchToCurl from 'fetch-to-curl'

import {
    applyDefaults,
    handleStreamingResponse,
    useHandleResponseError,
    useAbortController,
} from '../../utils'
import useChatHistory from '../../components/History/useChatHistory'
import useScrollToBottom from 'utils/useScrollToBottom'
import { getRequestHeaders } from '../../requestHeder'

export const useTextPrompting = () => {
    const { handleResponseError } = useHandleResponseError()
    const { createAbortController, abort } = useAbortController()
    const { scrollRef, scrollToBottom } = useScrollToBottom()

    const [isLoading, setIsLoading] = useState(false)
    const [isStreaming, setIsStreaming] = useState(false)

    const {
        chat,
        chatHistory,
        updateMessagesAndHistory,
        handleStartNewChat,
        setChat,
        handleDeleteHistory,
    } = useChatHistory()

    const [cUrl, setCurl] = useState<string>('')

    const initialValues = {
        streamingResponse: true,

        query: '',
    }

    const request_headers = getRequestHeaders()

    const handleSubmit = async (values: any, signal: AbortSignal) => {
        try {
            const finalValues = applyDefaults(values, initialValues)

            updateMessagesAndHistory(finalValues.query, 'You')

            const queryUrl = `${
                import.meta.env.REACT_APP_SUBNET_API
            }/s1_alpha?synapse_type=StreamPromptingSynapse&streaming_response_enabled=${
                finalValues.streamingResponse
            }`

            const options = {
                method: 'POST',
                headers: request_headers as any,
                body: JSON.stringify({
                    query: [finalValues.query],
                    roles: ['user'],
                }),
                signal,
            }

            const curlString = fetchToCurl(queryUrl, options)?.replace(/\$/g, '\\$')

            const response: any = await fetch(queryUrl, options)

            await handleResponseError(response)

            setCurl(curlString)

            if (!response.body) return

            handleStreamingResponse(
                response,
                (text: string) => {
                    updateMessagesAndHistory(text, 'AlphaLLM', true, curlString)
                },
                () => {
                    setIsStreaming(false)
                },
            )
        } catch (e) {
            console.log(e)
        }
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: async (values, formikHelpers) => {
            formikHelpers.setFieldValue('query', '') // Reset message to empty string immediately
            setIsLoading(true)
            scrollToBottom()
            const signal = createAbortController()
            await handleSubmit(values, signal)
            setIsLoading(false)
        },
    })

    const handleStopRequest = () => {
        abort()
        setIsStreaming(false)
    }

    return {
        responseLoading: isLoading,
        formik,
        chat,
        chatHistory,
        handleStartNewChat,
        setChat,
        handleDeleteHistory,
        cUrl,
        scrollRef,
        handleStopRequest,
        requestLoading: isStreaming || isLoading,
    }
}
